/**
 *
 */
export const state = () => ({
    isTouchEnabled: true,
    isMapInteractive: true,
});

export const mutations = {
    setIsTouchEnabled(state, flag) {
        state.isTouchEnabled = flag;
    },
    setIsMapInteractive(state, flag) {
        state.isMapInteractive = flag;
    },
};
